import dashboardProvider from './dashboardProvider';
/**
 * @ngdoc module
 * @name mcb.components.dashboard
 */
export default angular
  .module('mcb.components.dashboard', [])
  .provider('mcbDashboard', dashboardProvider);
